import React from 'react';

const CommunityContentIdProp = React.PropTypes.shape({
  type: React.PropTypes.number.isRequired,
  relatedId: React.PropTypes.string.isRequired,
  secondaryRelatedId: React.PropTypes.string,
});

export default CommunityContentIdProp;
